import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { GrnReturns } from "./grn-return-entity";

@Entity("grn_item_returns", { schema: "erp_procurement" })
export class GrnItemReturns {
  @PrimaryGeneratedColumn({ type: "int", name: "grn_return_item_id", comment: "Grn return id" })
  grnReturnItemId: number;

  @Column("int", {
    nullable: false,
    name: "item_category_id"
  })
  itemCategoryId: number;

  @Column("int", {
    nullable: false,
    name: "grn_item_id"
  })
  grnItemId: number;

  @Column("int", {
    nullable: false,
    name: "stock_id"
  })
  stockId: number;

  @Column("int", {
    nullable: false,
    name: "grn_id"
  })
  grnId: number;

  @Column("int", {
    nullable: false,
    name: "item_sub_category_id"
  })
  itemSubCategoryId: number;

  @Column("int", {
    nullable: true,
    name: "size_id",
    default:0
  })
  sizeId: number;

  @Column("int", {
    nullable: false,
    name: "item_id"
  })
  itemId: number;

  @Column({
    type: "decimal", precision: 10, scale: 3,
    nullable: false,
    name: "available_qty",
    default: 0,
    unsigned: true
  })
  grnReceiveQty: number;

  @Column({
    type: "decimal", precision: 10, scale: 3,
    nullable: false,
    name: "grn_receive_qty",
    default: 0,
    unsigned: true
  })
  availableQty: number;

  @Column({
    type: "decimal", precision: 10, scale: 3,
    nullable: false,
    name: "grn_return_qty",
    default: 0,
    unsigned: true
  })
  grnReturnQty: number;

  @Column({
    type: "decimal", precision: 10, scale: 3,
    nullable: false,
    name: "unit_price",
    default: 0,
    unsigned: true
  })
  unitPrice: number;

  @Column({
    type: "decimal", 
    nullable: false,
    name: "discount_percentage",
    default: 0,
    unsigned: true
  })
  discountPercentage: number;

  @Column({
    type: "decimal", precision: 10, scale: 3,
    nullable: false,
    name: "discount_amount",
    default: 0,
    unsigned: true
  })
  discountAmount: number;

  @Column({
    type: "decimal", 
    nullable: false,
    name: "tax_percentage",
    default: 0,
    unsigned: true
  })
  taxPercentage: number;

  @Column({
    type: "decimal", precision: 10, scale: 3,
    nullable: false,
    name: "tax_amount",
    default: 0,
    unsigned: true
  })
  taxAmount: number;

  @Column({
    type: "decimal", precision: 10, scale: 3,
    nullable: false,
    name: "grn_total_return_price",
    default: 0,
    unsigned: true
  })
  grnTotalReturnPrice: number;

  @Column("varchar", {
    nullable: true,
    length: 30,
    name: "remarks"
  })
  remarks: string;

  @CreateDateColumn({ name: "created_at" })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    length: 40,
    name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({ name: "updated_at" })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    length: 40,
    name: "updated_user"
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(type => GrnReturns, grn => grn.grnReturnItemsInfo, { nullable: false, })
  @JoinColumn({ name: "grn_return_id" })
  grnReturnInfo: GrnReturns[];
}